import React, { useEffect } from 'react';
import 'react-circular-progressbar/dist/styles.css';
import { useDispatch } from 'react-redux';
import Spinner from '../../components/common/Spinner';
import { useAppSelector } from '../../app/hooks';
import { getEventDubaiPromo } from '../../slices/event-slice';
import { useTranslation } from 'react-i18next';

import { Desktop, Mobile } from '../../App';

import {
  BV,
  calculatePercentage,
  formatVP
} from '../../helpers/helperFunctions';
import {
  CaptionText,
  FooterText,
  H2,
  H3,
  H4,
  P2,
  P3
} from '../../styles/FontStyles';
import {
  Button,
  Flexed,
  ProgressBarWithPercentage,
  SectionSeparator
} from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import {
  Icon,
  IconArrowPolygon,
  IconCheckRanking,
  IconTier1,
  IconTier2,
  IconTier3,
  IconTier4
} from '../../styles/Icons';
import { Flex, ViewBackOffice } from '../../styles/stylesStyled';
import {
  ArrowTier,
  CheckboxRank,
  CountdownNumbers,
  MavieRank,
  PromotionStartEnd,
  TierBars,
  TierCircle,
  TierReward
} from './EventPromoStyled';

import dubaiPromo from '../../assets/images/backoffice/event/event.png';
import dubaiPromoMobile from '../../assets/images/backoffice/event/eventMobile.png';

import disco from '../../assets/icons/disco-ball.svg';

import Countdown from 'react-countdown';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import moment from 'moment';

export const EventPromoDubai = () => {
  const { t } = useTranslation('packages');
  const dispatch = useDispatch();

  const { loading, events } = useAppSelector((state) => state.events);

  useEffect(() => {
    dispatch(getEventDubaiPromo());
  }, [dispatch]);

  if (loading) {
    return <Spinner fullScreen />;
  }

  interface HasConditionProps {
    hasCondition: boolean;
  }

  const timestamp = moment().endOf('month').valueOf();

  interface RendererProps {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }

  const showPersonalSalesTierAmount = (i: number, item: any) => {
    if (i === 0 && events?.personalSalesAmount <= 1000) {
      return <div key={i}>{formatVP(events?.personalSalesAmount)}</div>;
    } else if (
      i === 1 &&
      events?.personalSalesAmount > 1000 &&
      events?.personalSalesAmount <= 3000
    ) {
      return <div key={i}>{formatVP(events?.personalSalesAmount)}</div>;
    } else if (
      i === 2 &&
      events?.personalSalesAmount > 3000 &&
      events?.personalSalesAmount <= 5000
    ) {
      return <div key={i}>{formatVP(events?.personalSalesAmount)}</div>;
    } else if (
      i === 3 &&
      events?.personalSalesAmount > 5000 &&
      events?.personalSalesAmount <= 20000
    ) {
      return <div key={i}>{formatVP(events?.personalSalesAmount)}</div>;
    } else if (
      i === 3 &&
      events?.personalSalesAmount > item?.personalSalesProgress?.required
    ) {
      return (
        <div key={i}>{formatVP(item?.personalSalesProgress?.required)}</div>
      );
    }
  };

  const showDirectVolumeTierAmount = (i: number, item: any) => {
    if (events?.directVolumeAmount <= 2000 && i === 0) {
      return <div key={i}>{formatVP(events?.directVolumeAmount)}</div>;
    } else if (
      i === 1 &&
      events?.directVolumeAmount > 2000 &&
      events?.directVolumeAmount <= 5000
    ) {
      return <div key={i}>{formatVP(events?.directVolumeAmount)}</div>;
    } else if (
      i === 2 &&
      events?.directVolumeAmount > 5000 &&
      events?.directVolumeAmount <= 15000
    ) {
      return <div key={i}>{formatVP(events?.directVolumeAmount)}</div>;
    } else if (
      i === 3 &&
      events?.directVolumeAmount > 15000 &&
      events?.directVolumeAmount <= 50000
    ) {
      return <div key={i}>{formatVP(events?.directVolumeAmount)}</div>;
    } else if (
      i === 3 &&
      events?.directVolumeAmount > item?.directVolumeProgress?.required
    ) {
      return (
        <div key={i}>{formatVP(item?.directVolumeProgress?.required)}</div>
      );
    }
  };

  const showPaidTeamTierAmount = (i: number, item: any) => {
    if (events?.paidTeamAmount <= 2000 && i === 0) {
      return <div key={i}>{formatVP(events?.paidTeamAmount)}</div>;
    } else if (
      i === 1 &&
      events?.paidTeamAmount > 2000 &&
      events?.paidTeamAmount <= 5000
    ) {
      return <div key={i}>{formatVP(events?.paidTeamAmount)}</div>;
    } else if (
      i === 2 &&
      events?.paidTeamAmount > 5000 &&
      events?.paidTeamAmount <= 15000
    ) {
      return <div key={i}>{formatVP(events?.paidTeamAmount)}</div>;
    } else if (
      i === 3 &&
      events?.paidTeamAmount > 15000 &&
      events?.paidTeamAmount <= 50000
    ) {
      return <div key={i}>{formatVP(events?.paidTeamAmount)}</div>;
    } else if (
      i === 3 &&
      events?.paidTeamAmount > item.paidTeamProgress.required
    ) {
      return <div key={i}>{formatVP(item.paidTeamProgress.required)}</div>;
    }
  };

  const renderer: React.FC<RendererProps> = ({
    days,
    hours,
    minutes,
    seconds,
    completed
  }: any) => {
    return (
      <div
        style={{
          width: 212,
          height: 212,
          position: 'relative',
          border: '3px solid #DBCEA2',
          borderRadius: '50%',
          padding: 3,
          background:
            'linear-gradient(316.54deg, #FADF7F -251.77%, #ECDEAF -92.56%, #000000 84.14%)'
        }}>
        <CountdownCircleTimer
          isPlaying={!completed}
          duration={60}
          colors={['#ffffff', '#ffffff']}
          trailColor={'#DBCEA2'}
          colorsTime={[60, 60]}
          onComplete={() => {
            // do your stuff here
            return { shouldRepeat: true, delay: 0 }; // repeat animation in 1.5 seconds
          }}
          initialRemainingTime={seconds}
          size={200}
          strokeWidth={15}
          strokeLinecap={'square'}></CountdownCircleTimer>
        <div
          style={{
            width: 200,
            height: 200,
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          <CountdownNumbers ticketPromotion={false}>
            <div>
              <H3>{days}</H3>
              <CaptionText caps> {t('days')}</CaptionText>
            </div>
            <div>
              <H3>{hours}</H3>
              <CaptionText caps> {t('hours')}</CaptionText>
            </div>
            <div>
              <H3>{minutes}</H3>
              <CaptionText caps> {t('minutes')}</CaptionText>
            </div>
          </CountdownNumbers>
        </div>
      </div>
    );
  };

  return (
    <ViewBackOffice>
      <MavieRank>
        <Desktop>
          <section style={{ position: 'relative' }}>
            <img src={dubaiPromo} alt='dubaiPromo' style={{ width: '100%' }} />
            <div style={{ position: 'absolute', right: 50, top: 20 }}>
              <Countdown date={timestamp} renderer={renderer} />
            </div>
          </section>
        </Desktop>
        <Mobile>
          {' '}
          <section style={{ position: 'relative' }}>
            <img
              src={dubaiPromoMobile}
              alt='dubaiPromo'
              style={{ width: '100%' }}
            />
          </section>
        </Mobile>
        <div>
          <Desktop>
            <Flexed center between>
              <P2 color={color.colors.neutral500} maxWidth='70%'>
                {`Elevate your lifestyle and drive in style. We are excited to introduce a premium performance bonus added directly to our compensation plan for active members. Unlock your monthly car allowance by maintaining your active status and reaching your targets. Your journey to the top deserves a world-class ride.`}
              </P2>
            </Flexed>
            <SectionSeparator margin='40px 0' />
            <PromotionStartEnd>
              <div>
                <CaptionText caps mb='8' color={color.colors.neutral500}>
                  program starts
                </CaptionText>
                <H3>February 1, 2026, 00:00 UTC</H3>
              </div>

              <div>
                <CaptionText caps mb='8' color={color.colors.neutral500}>
                  valid
                </CaptionText>
                <H3>Repeating every month!</H3>
              </div>
            </PromotionStartEnd>
          </Desktop>
          <Mobile>
            <div>
              <P2 color={color.colors.neutral500} mb='32'>
                {`Elevate your lifestyle and drive in style. We are excited to introduce a premium performance bonus added directly to our compensation plan for active members. Unlock your monthly car allowance by maintaining your active status and reaching your targets. Your journey to the top deserves a world-class ride.`}
              </P2>

              <CaptionText caps mb='4' mt='32' color={color.colors.neutral500}>
                promotion starts
              </CaptionText>
              <H3 mb='16'>Fevruary 1, 2024, 00:00 UTC</H3>

              <CaptionText caps mb='4' color={color.colors.neutral500}>
                promotion ends
              </CaptionText>

              <CaptionText caps mb='4' color={color.colors.neutral500}>
                valid
              </CaptionText>
              <H3 mb='16'>Repeating every month!</H3>
            </div>
          </Mobile>
          <CaptionText caps color={color.colors.neutral500} mb='12' mt='50'>
            Track your progress
          </CaptionText>
          <P3 semiBold color={color.colors.neutral900} mb='20'>
            Personal Sales (direct)
          </P3>

          <Flexed center between mb='7'>
            <CaptionText color={color.colors.neutral700}>
              Current: {formatVP(events?.pv?.current)}
            </CaptionText>
            <CaptionText color={color.colors.neutral700}>
              Required: {formatVP(events?.pv?.required)} PV
            </CaptionText>
          </Flexed>
          <ProgressBarWithPercentage
            percentage={calculatePercentage(
              events?.pv?.current,
              events?.pv?.required
            )}
            color={color.colors.success500}>
            <div>
              <div>
                {calculatePercentage(events?.pv?.current, events?.pv?.required)}
                %
              </div>
            </div>
          </ProgressBarWithPercentage>

          <P3 semiBold color={color.colors.neutral900} mb='12' mt='20'>
            Team Volume (Weaker side):
          </P3>

          <Flexed center between mb='7'>
            <CaptionText color={color.colors.neutral700}>
              Current: {formatVP(events?.bv?.current)}
            </CaptionText>
            <CaptionText color={color.colors.neutral700}>
              Required: {formatVP(events?.bv?.required)} {BV}
            </CaptionText>
          </Flexed>
          <ProgressBarWithPercentage
            percentage={calculatePercentage(
              events?.bv?.current,
              events?.bv?.required
            )}
            color={color.colors.success500}>
            <div>
              <div>
                {calculatePercentage(events?.bv?.current, events?.bv?.required)}
                %
              </div>
            </div>
          </ProgressBarWithPercentage>

          <P3 semiBold color={color.colors.neutral900} mb='12' mt='20'>
            Unilevel Volume (Powerleg):
          </P3>

          <Flexed center between mb='7'>
            <CaptionText color={color.colors.neutral700}>
              Current: {formatVP(events?.uv?.current)}
            </CaptionText>
            <CaptionText color={color.colors.neutral700}>
              Required: {formatVP(events?.uv?.required)} UV
            </CaptionText>
          </Flexed>
          <ProgressBarWithPercentage
            percentage={calculatePercentage(
              events?.uv?.current,
              events?.uv?.required
            )}
            color={color.colors.success500}>
            <div>
              <div>
                {calculatePercentage(events?.uv?.current, events?.uv?.required)}
                %
              </div>
            </div>
          </ProgressBarWithPercentage>
        </div>
      </MavieRank>
    </ViewBackOffice>
  );
};
